export enum SelectorType {
  CHALLENGE = 'challenge',
  PHASE = 'phase',
  MILESTONE = 'milestone',
  MILESTONE_MODERATE = 'milestoneModeration',
  MILESTONE_VOTE = 'milestoneVote'
}
